const isDev = process.env.NODE_ENV === 'development';

export function logError(context, error) {
  if (isDev) {
    console.error(`[${context}]`, error);
  }
}
